import { createClient } from "@supabase/supabase-js";

const supabaseUrl = "https://fbnbjxvvtiuxajupkars.supabase.co";
const supabaseAnonKey = "sb_publishable_XnJoRFLeFYHFY7b288E3Dw_5Vm2-DHm";

export const supabase = createClient(supabaseUrl, supabaseAnonKey);